import { Col, Divider, Input, Pagination, Row } from 'antd';
import { gatewayApi } from 'api/gatewayApi';
import AddEditFormGateway from 'components/Common/Modal/AddEditFormGateway';
import { GatewayInfo } from 'models/gateway';
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import style from '../Components.module.scss';
import GatewayInformation from '../GatewayInfo/GatewayInfo';
import ItemGatewayList from '../ItemGatewayList/ItemGatewayList';

export interface GatewaysProps {}

export default function Gateways(props: GatewaysProps) {
  const [pagePlant, setPagePlant] = React.useState<number>(0);
  // const [isEvent, setIsEvent] = React.useState<boolean>(false);
  const isEvent: boolean = false;
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [isShowGatewayDetail, setIsShowGatewayDetail] = React.useState(true);

  const onChangeValue = async (e: any) => {
    const val = e.target.value;
    const res = await gatewayApi.fetchGateways({
      _limit: 10,
      _page: 0,
      search_label: `&search_label=${val}`,
    });
    setGatewayList(res.data);
  };

  const onChangePage = (page: number) => {
    setPagePlant(page - 1);
  };
  const [gatewayList, setGatewayList] = React.useState<GatewayInfo[]>();
  React.useEffect(() => {
    (async () => {
      try {
        const res = await gatewayApi.fetchGateways({ _limit: 10, _page: 0, search_label: null });
        console.log('Log: ~ file: Gateways.tsx ~ line 39 ~ res', res);
        setGatewayList(res.data);
      } catch (error) {
        console.log('Failed to fetch student details', error);
      }
    })();
  }, []);

  return (
    <>
      {isShowGatewayDetail ? (
        <Row className={style.root}>
          <Row className={style.header_info}>
            <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
              List of gateway
            </Divider>
          </Row>
          <Row className={style.main}>
            <Row className={style.header_main}>
              <Input
                onPressEnter={(e) => onChangeValue(e)}
                size="large"
                placeholder="Search by label"
                prefix={<FaSearch />}
                className={style.search_header}
              />
              <FiPlus
                onClick={() => {
                  setIsModalVisible(!isModalVisible);
                }}
                className={style.btn_create}
                size={20}
              />
            </Row>
            <div className={style.main_table}>
              <Row className={style.header_table}>
                <Col className={style.item_header} span={4}>
                  CODE
                </Col>
                <Col className={style.item_header} span={8}>
                  LABEL
                </Col>
                <Col className={style.item_header} span={5}>
                  STATUS
                </Col>
                <Col className={style.item_header} span={7}>
                  LAST ACTIVITY TIME
                </Col>
              </Row>
              <div className={style.content_table} id={style.style_4}>
                {gatewayList?.map((item, index) => {
                  return (
                    index >= pagePlant * 10 &&
                    index < (pagePlant + 1) * 10 && (
                      <ItemGatewayList
                        key={item.id}
                        item={item}
                        setIsShowGatewayDetail={setIsShowGatewayDetail}
                      />
                    )
                  );
                })}
              </div>
            </div>
          </Row>
          <Row className={style.footer_list}>
            <Pagination
              size="small"
              pageSize={10}
              defaultCurrent={pagePlant + 1}
              total={gatewayList?.length}
              onChange={onChangePage}
              showSizeChanger={false}
              showQuickJumper={false}
            />
          </Row>
        </Row>
      ) : (
        <GatewayInformation
          isShowGatewayDetail={isShowGatewayDetail}
          setIsShowGatewayDetail={setIsShowGatewayDetail}
          setGatewayList={setGatewayList}
        />
      )}
      <AddEditFormGateway
        isEvent={isEvent}
        itemGateway={undefined}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setGatewayList={setGatewayList}
      />
    </>
  );
}
